module.exports = __webpack_public_path__ + "static/media/DiscordLogo.1c8a54f2.svg";


//////////////////
// WEBPACK FOOTER
// ./client/src/img/DiscordLogo.svg
// module id = 421
// module chunks = 0